import { NUMBERS_ONLY } from 'utils/validation';
import * as yup from 'yup';

export const schema = yup.object().shape({
  otp: yup
    .string()
    .nullable()
    .required('Please enter your one-time passcode to access Manage your Mortgage.')
    .min(6, 'Please enter your 6 digit one-time passcode.')
    .max(6, 'Please enter your 6 digit one-time passcode.')
    .matches(NUMBERS_ONLY, 'Please enter your 6 digit one-time passcode.')
});
